import { MdDeleteOutline, MdEdit } from "react-icons/md";
import { Action } from "./Table";

export const defaultActions: Action[] = [
  {
    label: "Editar",
    onClick: () => {},
    icon: <MdEdit size={20} />,
  },
  {
    label: "Eliminar",
    onClick: () => {},
    icon: <MdDeleteOutline size={20} />,
  },
];
